import { encodeParams, sendMessageToWidgets, handleMessageTypes } from './utils';

function embedHandler(iframeSelector, baseUrl) {
  function addIframeParams() {
    const ifr = document.querySelector(iframeSelector);
    if (ifr) {
      let { src } = ifr;
      if (src.includes('jsForm=true')) {
        return;
      }
      const parentURL = window.location.href;
      let queryParameters = '';
      if (parentURL && parentURL.indexOf('?') > -1) {
        queryParameters = parentURL.substring(parentURL.indexOf('?') + 1).split('&');
        queryParameters = encodeParams(queryParameters);
      }

      if (src && src.indexOf('?') > -1) {
        let iframeParams = src.substr(src.indexOf('?') + 1).split('&');
        iframeParams = encodeParams(iframeParams);
        queryParameters += `&${iframeParams}`;
        src = src.substring(0, src.indexOf('?'));
      }
      queryParameters += `&isIframeEmbed=1&parentURL=${encodeURIComponent(parentURL)}`;
      ifr.src = `${src}?${queryParameters}`;
    }
  }

  function handleIFrameMessage(e) {
    if (typeof e.data === 'object') {
      return;
    }
    const args = e.data.split(':');
    const iframe = document.querySelector(iframeSelector);
    if (!iframe) {
      return;
    }

    // add base url to permitted domains
    let permittedDomains = [];
    if (baseUrl) {
      const { hostname } = new URL(baseUrl);
      permittedDomains = [hostname];
    } else {
      permittedDomains = ['jotform.com', 'jotform.pro'];
    }

    handleMessageTypes(args, e, permittedDomains, iframeSelector);

    sendMessageToWidgets(e, iframe, permittedDomains);
  }

  function isPermitted(originUrl, whitelistedDomains) {
    const url = document.createElement('a');
    url.href = originUrl;
    const { hostname } = url;
    let result = false;
    if (typeof hostname !== 'undefined') {
      whitelistedDomains.forEach(element => {
        if (
          hostname.slice(-1 * element.length - 1) === '.'.concat(element)
          || hostname === element
        ) {
          result = true;
        }
      });
      return result;
    }
  }

  // use functions
  addIframeParams();
  window.isPermitted = isPermitted;
  window.addEventListener('message', handleIFrameMessage, false);
}

window.jotformEmbedHandler = embedHandler;
